export const getDevicePlatform = () => {
	if (typeof navigator === "undefined") {
		return {
			device: "unknown",
			os: "unknown",
			browser: "unknown"
		};
	}

	const ua = navigator.userAgent;

	const isIOS = /iPhone|iPad|iPod/i.test(ua);
	const isIPadOS = navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 1;
	const isAndroid = /Android/i.test(ua);
	const isWindows = /Windows NT/i.test(ua);
	const isMac = /Macintosh/i.test(ua) && !isIOS;
	const isLinux = /Linux/i.test(ua) && !isAndroid;
	const isStandalonePWA = window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;

	const isMobile = /Mobi|Android/i.test(ua);
	const isTablet = /iPad|Tablet/i.test(ua);
	const isDesktop = !isMobile && !isTablet;

	let browser = "unknown";
	if (/Chrome/i.test(ua) && !/Edg/i.test(ua)) browser = "chrome";
	else if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) browser = "safari";
	else if (/Firefox/i.test(ua)) browser = "firefox";
	else if (/Edg/i.test(ua)) browser = "edge";

	let os = "unknown";
	if (isIOS || isIPadOS) os = "ios";
	else if (isAndroid) os = "android";
	else if (isWindows) os = "windows";
	else if (isMac) os = "macos";
	else if (isLinux) os = "linux";

	let device = "unknown";
	if (isMobile) device = "mobile";
	else if (isTablet) device = "tablet";
	else if (isDesktop) device = "desktop";

	return {
		device,
		os,
		browser,
		isIOS,
		isIPadOS,
		isAndroid,
		isMobile,
		isDesktop,
		isStandalonePWA
	};
};
